import { render, staticRenderFns } from "./MemberCompetencyDetail.vue?vue&type=template&id=bbfd5f46&scoped=true"
import script from "./MemberCompetencyDetail.vue?vue&type=script&lang=js"
export * from "./MemberCompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberCompetencyDetail.vue?vue&type=style&index=0&id=bbfd5f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfd5f46",
  null
  
)

export default component.exports